import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

export interface CardSelectOption {
  id: any;
  label: string;
  sublabel?: string;
  imageUrl?: string;
}

@Component({
  selector: 'app-card-select',
  templateUrl: './card-select.component.html',
  styleUrls: ['./card-select.component.scss']
})
export class CardSelectComponent {
  @Input() options: CardSelectOption[] = [];
  @Input() value: any = null;
  @Input() placeholder = 'Seleccionar';
  @Input() emptyMessage = 'No hay opciones disponibles';
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('trigger', { static: true }) triggerRef!: ElementRef<HTMLButtonElement>;

  open = false;
  // El panel usa position:fixed calculado a mano (en vez de absolute) porque
  // las cards del creador de eventos tienen overflow:hidden y recortarían el desplegable.
  panelStyle: { [key: string]: string } = {};

  constructor(private elementRef: ElementRef) {}

  get selected(): CardSelectOption | undefined {
    return this.options.find(option => option.id === this.value);
  }

  toggle(): void {
    if (this.options.length === 0) {
      return;
    }
    this.open ? this.close() : this.openPanel();
  }

  openPanel(): void {
    const rect = this.triggerRef.nativeElement.getBoundingClientRect();
    this.panelStyle = {
      position: 'fixed',
      top: `${rect.bottom + 6}px`,
      left: `${rect.left}px`,
      width: `${rect.width}px`
    };
    this.open = true;
  }

  close(): void {
    this.open = false;
  }

  trackByOptionId(_index: number, option: CardSelectOption): any {
    return option.id;
  }

  select(option: CardSelectOption): void {
    this.value = option.id;
    this.valueChange.emit(option.id);
    this.close();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.open && !this.elementRef.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  onViewportChange(): void {
    if (this.open) {
      this.close();
    }
  }
}
